import * as React from 'react';
import { useFormField } from '@cian/frontend-request-form-widget';

import { FIOSuggestContainer } from '../FIOSuggestContainer';
import { validateFio } from './utils';
import { IRequestFormQuestionField } from '../../types/requestForm/requestFormField';

export const FIOSuggestFieldContainer: React.FC<IRequestFormQuestionField> = props => {
  const {
    field: { value },
    meta: { error, touched },
    helpers: { setValue, setError },
  } = useFormField<string>({
    name: props.name,
    validate: validateFio,
  });

  const handleChange = React.useCallback(
    (newValue: string) => {
      const cleanValue = newValue.trim();
      if (value !== cleanValue) {
        setValue(cleanValue);

        setError('');
      }
    },
    [value, setValue, setError],
  );

  return <FIOSuggestContainer onChange={handleChange} error={touched ? error : undefined} initialValue={value} />;
};

FIOSuggestFieldContainer.displayName = 'FIOSuggestFieldContainer';
